module.exports = __webpack_public_path__ + "img/modal-exit.772824f3.png";